import ApiService from './ApiService';
import queryString from 'query-string';

export async function apiUpdateProfile(data) {
  return ApiService.fetchData({
    url: `Customer/UpdateProfile`,
    method: 'post',
    data,
  });
}

export async function apiDeleteMe(data) {
  return ApiService.fetchData({
    url: `Customer/DeleteMe`,
    method: 'post',
    data,
  });
}

export async function apiGetUserCards(data) {
  return ApiService.fetchData({
    url: `Customer/MyCards`,
    method: 'post',
    data,
  });
}

export async function apiDeleteUserCard(data) {
  return ApiService.fetchData({
    url: `Customer/DeleteMyCard?cardid=${data}`,
    method: 'delete',
  });
}

export async function apiRequestCardSetup() {
  return ApiService.fetchData({
    url: `Customer/SetupCardRequest`,
    method: 'post',
  });
}

export async function apiGetUserOrders(data) {
  return ApiService.fetchData({
    url: `Order/List/CustomerOrders?${queryString.stringify(data, {
      skipNull: true,
    })}`,
    method: 'get',
  });
}

export async function apiGetUserOrder(data) {
  return ApiService.fetchData({
    url: `Order/Get/CustomerOrder?id=${data}`,
    method: 'get',
  });
}

export async function apiAddRemoveFavoriteStore(id) {
  return ApiService.fetchData({
    url: `Customer/AddRemoveFavoriteStore?storeid=${id}`,
    method: 'put',
  });
}
